<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-left mb-4 mb-sm-0">
        <h3 class="page-title">
          <template v-if="isEdit">
            <template v-if="isSubcategory">Edytuj podkategorię produktów</template>
            <template v-else>Edytuj kategorię produktu</template>
          </template>
          <template v-else>
            <template v-if="isSubcategory">Nowa podkategoria produktów test</template>
            <template v-else>Nowy kategorię produktu</template>
          </template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="primary"
          outline
          @click.prevent="$router.push('/admin/product-types')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          <i class="material-icons">done</i>
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-card-body>
          <validation-observer
            v-if="allDataLoaded"
            ref="product-type-form"
            tag="form">
            <div class="form-group">
              <label for="name">
                Nazwa:
              </label>

              <validation-provider
                rules="required"
                name="Nazwa"
                v-model="data.name"
                v-slot="{ errors }">
                <d-input
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.name" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
            <div class="form-group">
              <toggle-switch v-model="data.use_drink_editor">
                Używaj edytora napojów
              </toggle-switch>
            </div>
            <div class="form-group" v-if="isSubcategory">
              <label for="parent_id">
                Kategoria nadrzędna:
              </label>

              <validation-provider
                :rules="isSubcategory ? 'required' : ''"
                name="Kategoria nadrzędna"
                v-model="data.parent_id"
                v-slot="{ errors }">
                <div
                  :class="{
                    'form-control is-select': true,
                    'is-invalid': errors.length,
                  }"
                >
                  <v-select
                    :options="parentTypes"
                    v-model="data.parent_id"
                    :reduce="type => type.id"
                    label="name"
                    :searchable="false"
                    :clearable="false"
                    placeholder="Wybierz kategorię nadrzędną" />
                </div>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </validation-observer>

          <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
            Trwa ładowanie danych&hellip;
          </div>

          <d-alert
            v-if="loadError"
            show
            theme="warning">
            Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
          </d-alert>
        </d-card-body>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import ToggleSwitch from './../common/ToggleSwitch.vue';

export default {
  name: 'product-type-form',
  components: {
    'toggle-switch': ToggleSwitch
  },
  computed: {
    allDataLoaded () {
      return this.loaded && (!this.isSubcategory || this.parentTypesLoaded);
    },
    isEdit () {
      return !!this.$route.params.id;
    },
    isSubcategory () {
      return this.$route.query.subcategory === 'true';
    }
  },
  data() {
    return {
      data: {
        id: 0,
        name: '',
        parent_id: null,
        use_drink_editor: false,
        subcategory: this.$route.query.subcategory === 'true'
      },
      parentTypes: [],
      parentTypesLoaded: false,
      loaded: false,
      loadError: false
    };
  },
  mounted () {
    if (this.isSubcategory) {
      this.loadParentTypes();
    }

    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/products/types/item/',
        instanceFields: ['id', 'name', 'use_drink_editor', 'parent_id'],
        booleanFields: ['use_drink_editor'],
        loadedKey: 'loaded'
      });
    },
    loadParentTypes () {
      this.$http.post('/products/types/parents')
        .then(response => {
          if (response.data.success) {
            this.parentTypes = response.data.items;
          }
          this.parentTypesLoaded = true;
        })
        .catch(() => {
          this.parentTypesLoaded = true;
        });
    },
    validateForm () {
      FormUtils.validate(this.$refs['product-type-form'], this.submitForm);
    },
    submitForm () {
      let endpointUrl = this.isEdit ? '/products/types/update/' + this.id : '/products/types/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: this.data,
        successTitle: 'Zapisano kategorię produktu',
        successText: 'Wybrana kategoria produktu została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Zapis nie powiódł się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/admin/product-types')
        }
      });
    }
  }
};
</script>
